import React, { FC } from 'react';
import { OInlineMessageProps } from './OInlineMessage.types';
import { Wrapper, IconWrapper, ContentWrapper } from './OInlineMessage.styles';
import { AIcon, AIconSize } from '../../atoms/AIcon';
import { ABody, ABodySize, ABodyColor } from '../../atoms/ABody';
import { MButton, MButtonType, MButtonSize, MButtonIconPlacement } from '../../molecules/MButton';
import { MParagraph, MParagraphAlignment } from '../../molecules/MParagraph';

export const OInlineMessage: FC<OInlineMessageProps> = props => {
  const { status, aBody, mParagraph, mButton } = props;

  const renderIcon = () => {
    let iconName = 'icon-information';
    switch (status) {
      case 'Success':
        iconName = 'icon-success';
        break;
      case 'Warning':
        iconName = 'icon-alert';
        break;
      case 'ErrorSev1':
      case 'ErrorSev2':
      case 'Emergency':
        iconName = 'icon-cancel';
        break;
      default:
        iconName = 'icon-information';
        break;
    }
    return <AIcon icon={iconName} size={AIconSize.S} />;
  };

  return (
    <Wrapper data-componentid="OInlineMessage" status={status}>
      <IconWrapper>{renderIcon()}</IconWrapper>
      <ContentWrapper>
        {aBody?.bodyText && (
          <ABody
            size={ABodySize.M}
            color={
              aBody.color === 'Default'
                ? ABodyColor.Default
                : aBody.color === 'Alternate'
                ? ABodyColor.Alternate
                : ABodyColor.Default
            }
            bodyText={aBody.bodyText}
          />
        )}
        {mParagraph?.aBody?.bodyText && (
          <MParagraph
            alignment={mParagraph.alignment === 'Centered' ? MParagraphAlignment.Center : MParagraphAlignment.Left}
            truncated={mParagraph.truncated === true}
            expanded={mParagraph.expanded === true}
            bodySize={
              mParagraph.aBody?.size === 'XS'
                ? ABodySize.XS
                : mParagraph.aBody?.size === 'M'
                ? ABodySize.M
                : ABodySize.S
            }
            bodyColor={
              mParagraph.aBody?.color === 'Default'
                ? ABodyColor.Default
                : mParagraph.aBody?.color === 'Alternate'
                ? ABodyColor.Alternate
                : ABodyColor.Default
            }
          >
            {mParagraph.aBody.bodyText}
          </MParagraph>
        )}
        {mButton?.buttonText && (
          <MButton
            variant={mButton.type || MButtonType.Primary}
            size={mButton.size || MButtonSize.M}
            iconPlacement={
              mButton.icon === 'Leading'
                ? MButtonIconPlacement.Leading
                : mButton.icon === 'Trailing'
                ? MButtonIconPlacement.Trailing
                : MButtonIconPlacement.None
            }
            href={mButton.ctaLink}
            isExternal={mButton.openInANewTab === 'true'}
          >
            {mButton.buttonText}
          </MButton>
        )}
      </ContentWrapper>
    </Wrapper>
  );
};
